import { apiClient } from '@/lib/api/client';
import type { ApiEnvelope } from '@/types/api';
import type {
  ContributionRequest,
  Contribution,
  ContributionQueryParams,
  ContributionRequestQueryParams,
} from '@/types/contribution';

export async function getContributionRequests(
  params?: ContributionRequestQueryParams
): Promise<ApiEnvelope<ContributionRequest[]>> {
  const searchParams = new URLSearchParams();
  if (params?.direction) searchParams.set('direction', params.direction);
  if (params?.status) searchParams.set('status', params.status);
  if (params?.search) searchParams.set('search', params.search);
  if (params?.page) searchParams.set('page', String(params.page));
  if (params?.per_page) searchParams.set('per_page', String(params.per_page));
  const qs = searchParams.toString();
  return apiClient.get<ContributionRequest[]>(
    `/api_partner/initiative_fund_requests_contributions${qs ? `?${qs}` : ''}`
  );
}

export async function acceptContributionRequest(
  id: number
): Promise<ApiEnvelope<ContributionRequest>> {
  return apiClient.post<ContributionRequest>(
    `/api_partner/contributions/requests/${id}/accept`
  );
}

export async function rejectContributionRequest(
  id: number
): Promise<ApiEnvelope<ContributionRequest>> {
  return apiClient.post<ContributionRequest>(
    `/api_partner/contributions/requests/${id}/reject`
  );
}

export async function getContributions(
  params?: ContributionQueryParams
): Promise<ApiEnvelope<Contribution[]>> {
  const searchParams = new URLSearchParams();
  if (params?.status) searchParams.set('status', params.status);
  if (params?.search) searchParams.set('search', params.search);
  if (params?.page) searchParams.set('page', String(params.page));
  if (params?.per_page) searchParams.set('per_page', String(params.per_page));
  const qs = searchParams.toString();
  return apiClient.get<Contribution[]>(
    `/api_partner/contributions${qs ? `?${qs}` : ''}`
  );
}
